import { render, staticRenderFns } from "./AssigneesField.vue?vue&type=template&id=dbe50c2a&"
import script from "./AssigneesField.vue?vue&type=script&lang=ts&"
export * from "./AssigneesField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports